import { PropsWithChildren } from 'react';

import { FormErrorFocus } from 'components';
import { Form } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import { useDialog } from 'libs/ui/Dialog/useDialog';
import { DialogVerificationCode } from 'modules/account/orderModule/common/components';
import { ConfirmationDocumentSectionProps } from 'modules/account/orderModule/common/components/sections';
import { DeepPartial } from 'types/deepPartial';

import { OrderFormType, FormErrors, getSchema } from '../../forms/orderForm';
import { useCreateOrderContext } from '../../providers/OrderProvider';

export interface CreateOrderFormProps extends ConfirmationDocumentSectionProps {
  onSubmit: (values: OrderFormType) => void;
  validateOrder: (values: OrderFormType) => Promise<boolean>;
  initialValues?: DeepPartial<OrderFormType>;
  formError?: FormErrors;
}

export const CreateOrderForm = ({
  children,
  initialValues,
  formError,
  onSubmit,
  validateOrder,
}: PropsWithChildren<CreateOrderFormProps>) => {
  const { t } = useTranslation();

  const { orderType, disabledDates, minEndDate } = useCreateOrderContext();

  const {
    isOpen: isOpenVerificationDialog,
    open: openVerificationDialog,
    onClose: onCloseVerificationDialog,
  } = useDialog();

  const handleOnSubmit = (values: OrderFormType) => {
    if (isOpenVerificationDialog) {
      onSubmit(values);
    } else {
      validateOrder(values).then((isValid) => {
        if (isValid) {
          openVerificationDialog();
        }
      });
    }
  };

  return (
    <Form
      initialErrors={formError}
      initialValues={initialValues}
      validationSchema={getSchema(t, {
        orderType,
        minEndDate,
        disabledDates,
      })}
      onSubmit={handleOnSubmit}
    >
      <FormErrorFocus />

      {children}

      {/* <Stack flex={1} spacing={40} spacingMobile={32}>
        <Stack spacing={32}>
          <ExecutionPeriodSection />
          <ExecutionTermsSection
            isShowOperationKind={isWithdrawalOrDeposit}
            isShowOperationPurpose={isPurchaseOrSale && isFinance}
            isShowOrderType={isPurchaseOrSale}
            isShowYield={isPurchaseOrSale}
          />
          <FinancialInstrumentSection />
          {isPurchaseOrSale && <TransactionVolumeSection />}
          {isWithdrawalOrDeposit && <TransferVolumeSection />}
          {isWithdrawalOrDeposit && (
            <SenderOrRecipientDetailsSection type="sender" />
          )}
          {isWithdrawalOrDeposit && (
            <SenderOrRecipientDetailsSection type="recipient" />
          )}
          {isWithdrawalOrDeposit && <AdditionalParametersSection />}
          {isWithdrawalOrDeposit && <ConfirmationDocumentSection />}
        </Stack>
      </Stack>

      <FormFooter
        backLink={ROUTES.account.orders.fullPath}
        submitLabel={t('account.createOrder.submitLabel')}
        submitLoading={submitLoading}
      /> */}

      <DialogVerificationCode<OrderFormType>
        codeFieldName="otpCode"
        isOpen={isOpenVerificationDialog}
        orderType={orderType!}
        onClose={onCloseVerificationDialog}
      />
    </Form>
  );
};
